import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { ProviderRecommendationData } from '../../../../store/Recommendations.model';
import type { IRootDispatch, RootState } from '../../../../store/models';

export default function useProviderRecommendations(
  providerId: string | number,
): ProviderRecommendationData {
  const dispatch = useDispatch<IRootDispatch>();
  const providerData = useSelector<RootState, ProviderRecommendationData>(
    state => state.recommendations.providers[providerId] as ProviderRecommendationData,
  );

  React.useEffect(() => {
    if (!providerData) {
      dispatch.recommendations.loadProviderRecommendations({
        providerId,
      });
    }
  }, [
    providerData,
    dispatch.recommendations,
    providerId,
  ]);
  return providerData;
}
